import { motion } from "motion/react";
import { ApplicationKRIOverview } from "./components/ApplicationKRIOverview";

/* ══════════════════════════════════════════════════════════════════════
   SYSTEM OWNER DASHBOARD — the Application Manager persona's landing page
   (Application Manager maps to the system_owner role; there is no separate
   role for it). Was previously the "Application" tab inside the Auditor's
   Group Auditor Dashboard; moved here since an Auditor should not see it
   and a System Owner should see it by default. Currently backed by mock
   data (applicationKriData.ts) until the application-manager endpoints are
   available — layout/UI only per this iteration.

   No page title/subtitle here — DashboardRouter's shared header ("System
   Owner Dashboard") already covers it, and a second title directly above
   would just duplicate it. ═══════════════════════════════════════════ */
export function SystemOwnerDashboard() {
  return (
    <motion.div
      className="space-y-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25 }}
    >
      <ApplicationKRIOverview />
    </motion.div>
  );
}
